const { AVAILABILITY_FAILURE } = require('../../constants/metrics');
const { queue } = require('../subscriptions');

const availabilityResourcesMonitor = () => {
  const { _pfl } = window;
  (_pfl || []).forEach((entry) => {
    const [initiator, filename] = entry;

    queue(AVAILABILITY_FAILURE, {
      filename,
      initiator,
      value: 1,
    });
  });
};

module.exports = availabilityResourcesMonitor;
